import 'formdata-polyfill';

export const FormAjaxifier = {
	ajaxify: ( form ) => {
		form.addEventListener( 'submit', function( e ) {
			onFormSubmit( form, e );
		} );
	},
};

function onFormSubmit( form, e ) {
	e.preventDefault();
	if ( isSubmitting( form ) ) {
		return false;
	}
	removeMessages( form );
	disableSubmitButton( form );
	setSubmittingState( form );
	ajaxSubmit( form );
}

function ajaxSubmit( form ) {
	const formData = new FormData( form );
	fetch( form.getAttribute( 'action' ), {
		method: form.getAttribute( 'method' ),
		body: formData,
	} ).then( ( res ) => res.json() )
		.then( ( response ) => {
			if ( response.success === true ) {
				import( './' + formData.get( 'action' ) + 'FormCallback.js' )
					.then( ( module ) => {
						module.callbacks.success( form, response.data );
					} )
					.catch( ( err ) => {
						console.error( err );
					} );

			} else if ( response.data[ 0 ].message !== '' ) {
				addMessage( form, response.data[ 0 ].message, 'error' );
			}
			enableSubmitButton( form );
			removeSubmittingState( form );
		} )
		.catch( ( error ) => {
			addMessage( form, error, 'error' );
		} );
}

function isSubmitting( form ) {
	return form.classList.contains( 'submitting' );
}

function setSubmittingState( form ) {
	form.classList.add( 'submitting' );
}

function removeSubmittingState( form ) {
	form.classList.remove( 'submitting' );
}

function removeMessages( form ) {
	form.querySelector( '.result-messages' ).innerHTML = '';
}

function disableSubmitButton( form ) {
	form.querySelector( '.submit-btn' ).setAttribute( 'disabled', '' );
}

function enableSubmitButton( form ) {
	form.querySelector( '.submit-btn' ).removeAttribute( 'disabled' );
}

function addMessage( form, message, type ) {
	const resultMessages = form.querySelector( '.result-messages' );
	let className = '';
	if ( type === 'error' ) {
		className = 'text-danger';
	}
	const messageElement = document.createElement( 'div' );
	messageElement.classList.add( className );
	messageElement.innerHTML = '<div>' + message + '</div>';
	resultMessages.appendChild( messageElement );
}
